export default {
  startNew: 'Start New Parser File',
  section: 'Parser Section',
  required: 'Fill out the required * field configuration below.',
  code_comment: 'you will see a preview of your parser file here',
}